import { render, staticRenderFns } from "./LKMunMehReviewLink.vue?vue&type=template&id=3119177e&"
import script from "./LKMunMehReviewLink.vue?vue&type=script&lang=js&"
export * from "./LKMunMehReviewLink.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehReviewLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports